import { render, staticRenderFns } from "./HbzyglList.vue?vue&type=template&id=4d88d5f5"
import script from "./HbzyglList.vue?vue&type=script&lang=js"
export * from "./HbzyglList.vue?vue&type=script&lang=js"
import style0 from "./HbzyglList.vue?vue&type=style&index=0&id=4d88d5f5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports